import { useEffect } from "react";
import { SELAR_STORE_URL } from "../shared";

/**
 * Talent enablement modules are sold through Selar, not the in-app store
 * endpoint + Paystack checkout that used to live here.
 *
 * The route is kept so existing links — bookmarks, shared URLs, anything already
 * out in the wild — land on the Selar storefront rather than an abandoned
 * checkout that would charge against pricing Selar no longer controls.
 */
const TalentPreviewUI = () => {
  useEffect(() => {
    window.location.replace(SELAR_STORE_URL);
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <p className="text-base text-[#475467]">
        Taking you to the store…{" "}
        <a
          href={SELAR_STORE_URL}
          className="font-medium text-[#012169] underline"
          rel="noopener noreferrer"
        >
          Continue
        </a>
      </p>
    </div>
  );
};

export { TalentPreviewUI };
